import { fetchData } from "../../utils/Http"
import { serverUrl } from "../../utils/Settings"

type Response = Hotelstouch.WebApp.WebShop.Api.CartInfo.Response
type Request = Hotelstouch.WebApp.WebShop.Api.CartInfo.Request

export async function getCartInfo(params?: Request):Promise<Response>{
    return await fetchData<Response>(`${serverUrl}/api/publicWebShop/cartInfo`, params)
}